import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

export interface MetaWhatsappAccount {
  waba_id: string;
  phone_number_id: string;
  display_phone_number?: string;
  verified_name?: string;
  verified_at?: string;
  has_access_token?: boolean;
  /** App Secret gravado (nunca devolvido em claro) — a Meta assina os webhooks com ele. */
  has_app_secret?: boolean;
  active?: boolean;
}

export interface MetaTemplate {
  name: string;
  status: string;
  category: string;
  language: string;
  components?: any[];
  rejected_reason?: string;
}

export interface CreateTemplatePayload {
  name: string;
  category: 'MARKETING' | 'UTILITY';
  language: string;
  body: string;
  examples?: string[];
}

export interface LeadVariable {
  token: string;
  label: string;
}

/**
 * Leitura da integração principal, templates dela e catálogo de variáveis do lead. Criar,
 * editar, testar e excluir integrações (e templates) é pelo `WhatsappAccountsService`
 * (CU-17tm466mfzu).
 */
@Injectable({ providedIn: 'root' })
export class MetaWhatsappService {

  private base = `${environment.apiUrl}/meta-whatsapp/account`;

  constructor(private http: HttpClient) { }

  /**
   * `aiAgentId`: a integração do número desse agente (CU-17tm466mfzu) — é por ela que sai a 1ª
   * mensagem das listas dele. Sem agente (ou agente sem número), a principal.
   */
  get(aiAgentId?: string | null): Observable<MetaWhatsappAccount | null> {
    return this.http.get<MetaWhatsappAccount | null>(this.base, { params: agentParams(aiAgentId) });
  }

  listTemplates(aiAgentId?: string | null): Observable<MetaTemplate[]> {
    return this.http.get<MetaTemplate[]>(`${environment.apiUrl}/meta-whatsapp/templates`, { params: agentParams(aiAgentId) });
  }

  leadVariables(): Observable<LeadVariable[]> {
    return this.http.get<LeadVariable[]>(`${environment.apiUrl}/meta-whatsapp/lead-variables`);
  }
}

function agentParams(aiAgentId?: string | null): HttpParams {
  return aiAgentId ? new HttpParams().set('ai_agent_id', aiAgentId) : new HttpParams();
}
